import React, { memo, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { AccountCreateContext } from '@components-member/TradingAccounts/AccountCreate/context/accountCreateContext';
import { ACCOUNT_CREATE_STEP } from '@components-member/TradingAccounts/AccountCreate/interfaces';
import { TradingPlatform } from '@components-member/TradingAccounts/TradingPlatforms/TradingPlatform';
import { TradingPlatformHint } from '@components-member/TradingAccounts/TradingPlatforms/TradingPlatformHint';
import { keyMap } from '@locales/lokalise/keyMap';
import styles from './tradingPlatform.module.scss';

interface ITradingPlatformViewProps {
  changeStep: (step: ACCOUNT_CREATE_STEP) => void;
}

export const TradingPlatforms = memo((props: ITradingPlatformViewProps): JSX.Element | null => {
  const { changeStep } = props;
  const { i18n } = useTranslation();
  const { availablePlatform, accountCreateState, contestId } = useContext(AccountCreateContext);
  const { tradingPlatformBrandingSettings } = accountCreateState.creationSetting;

  const changeStepHandler = () => changeStep(ACCOUNT_CREATE_STEP.CREATE);

  const platforms = tradingPlatformBrandingSettings.filter((platform) =>
    availablePlatform.has(platform.tradingPlatformType),
  );

  const isAvailablePlatformsExist = Boolean(platforms.length);

  return (
    <div className={styles.tradingPlatforms}>
      {isAvailablePlatformsExist ? (
        <>
          {contestId && (
            <div className={styles.tradingPlatforms__hintMessageContainer}>
              <span className={styles.hintMessage}>{i18n.t(keyMap.tradingContestInOrderToParticipateHintOne)}</span>
              <span className={styles.hintMessage}>{i18n.t(keyMap.tradingContestInOrderToParticipateHintTwo)}</span>
            </div>
          )}
          <h3 className={styles.tradingPlatforms__title}>{i18n.t(keyMap.accountChoosePlatform)}</h3>

          <div className={styles.tradingPlatforms__list}>
            {platforms.map((item) => {
              return (
                <TradingPlatform
                  key={item.id}
                  title={item.displayName}
                  description={item.description}
                  platform={item.tradingPlatformType}
                  id={item.id}
                  imageUniqueId={item.imageUniqueId}
                  changeStepHandler={changeStepHandler}
                />
              );
            })}
          </div>
        </>
      ) : (
        <TradingPlatformHint />
      )}
    </div>
  );
});

TradingPlatforms.displayName = 'TradingPlatform';
